<app-page-header
  [pageTitle]="isEditMode ? 'Editar zona' : 'Nueva zona'"
  [showBreadcrumb]="true"
  [backRoute]="'../'"
  [backLabel]="'Zonas'"
  [currentRoute]="isEditMode ? 'Editar' : 'Nueva'"
/>

@if (loadingData) {
  <app-spinner />
} @else {
  <app-card [title]="'Datos de la zona'">
    <app-form [formGroup]="saveForm">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
        <!-- Nombre -->
        <div>
          <app-label for="nombre">
            Nombre de la zona
          </app-label>
          <app-input-field id="nombre" type="text" formControlName="nombre" placeholder="Ingrese el nombre de la zona" />
        </div>

        <!-- País -->
        <div>
          <app-label for="pais">
            País
          </app-label>
          <app-select id="pais" formControlName="ubi_pais_id" placeholder="Seleccione un país" [options]="paises | toSelectOptions" />
        </div>

        <!-- Departamento -->
        <div>
          <app-label for="departamento">
            Departamento
          </app-label>
          <app-select id="departamento" formControlName="ubi_departamento_id" placeholder="Seleccione un departamento" [options]="departamentos | toSelectOptions" [disabled]="!saveForm.get('ubi_pais_id')?.value" />
        </div>

        <!-- Ciudad -->
        <div>
          <app-label for="ciudad">
            Ciudad
          </app-label>
          <app-select id="ciudad" formControlName="ubi_ciudad_id" placeholder="Seleccione una ciudad" [options]="ciudades | toSelectOptions" [disabled]="!saveForm.get('ubi_departamento_id')?.value" />
        </div>

      </div>
    </app-form>
  </app-card>

  @if (isEditMode) {
    <app-edition-buttons *hasPermission="'zonas:edit'"
      [process]="loading"
      [valid]="saveForm.valid"
      [editable]="false"
      (onUpdateClick)="saveZona()"
      (onCancelClick)="goBack()"
    />
  } @else {
    <app-creation-buttons *hasPermission="'zonas:create'"
      [process]="loading"
      [valid]="saveForm.valid"
      (onCreateClick)="saveZona()"
      (onCancelClick)="goBack()"
    />
  }
}
